import { createStore, applyMiddleware } from 'redux'
import { not, contains } from 'ramda'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
import sagas from './segas';
import reducers from './ducks';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// the logger master switch
const USE_LOGGING = false

// silence these saga-based messages
const SAGA_LOGGING_BLACKLIST = ['EFFECT_TRIGGERED', 'EFFECT_RESOLVED', 'EFFECT_REJECTED']

// create the logger
const logger = createLogger({
  predicate: (getState, { type }) => USE_LOGGING && not(contains(type, SAGA_LOGGING_BLACKLIST))
})

const persistConfig = {
  key: 'login',
  storage: storage,
  whitelist: ['login'] // which reducer want to store
};
const pReducer = persistReducer(persistConfig, reducers);

// a function which can create our store and auto-persist the data
//export default () => {
  const sagaMiddleware = createSagaMiddleware()
  const middleware = applyMiddleware(logger, sagaMiddleware)

  const store = createStore(pReducer, middleware)
  //const store = createStore(reducers, middleware)
  sagaMiddleware.run(sagas)

//   return store
// }
const persistor = persistStore(store);
export { persistor, store };




